import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { poolData } from './config';

export default new CognitoUserPool(poolData);